export const reorderItems = (
  items: Array<any>,
  startIndex: number,
  endIndex: number,
): Array<any> => {
  const result = Array.from(items);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);
  return result;
};
